import { ApplicationState } from "../..//types";

export const deleteNotice = (state: ApplicationState) => {
  state.notice = null;
};
